import React from 'react';
import { Star, Heart, Users, Lightbulb } from 'lucide-react';
import { mockHotelData } from './mock';

const Review = () => {
  const { personalReview } = mockHotelData;

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`${
          i < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
        }`}
        size={24}
      />
    ));
  };

  return (
    <section id="review" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            {personalReview.title}
          </h2>
          <div className="flex justify-center gap-1 mb-6">
            {renderStars(personalReview.rating)}
          </div>
          <div className="max-w-4xl mx-auto">
            <blockquote className="text-xl md:text-2xl text-gray-700 italic leading-relaxed">
              "{personalReview.review}"
            </blockquote>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Highlights */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <Heart className="text-red-500" size={28} />
              <h3 className="text-2xl font-bold text-gray-800">What We Loved</h3>
            </div>
            <div className="space-y-4">
              {personalReview.highlights.map((highlight, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                >
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mt-0.5">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-700 font-medium">{highlight}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Family Tips */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <Lightbulb className="text-yellow-500" size={28} />
              <h3 className="text-2xl font-bold text-gray-800">Family Tips</h3>
            </div>
            <div className="space-y-4">
              {personalReview.familyTips.map((tip, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-4 bg-yellow-50 rounded-lg hover:bg-yellow-100 transition-colors duration-200"
                >
                  <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center mt-0.5">
                    <Lightbulb className="w-3 h-3 text-white" />
                  </div>
                  <p className="text-gray-700 font-medium">{tip}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Overall Recommendation */}
        <div className="mt-16 text-center bg-white rounded-2xl p-8 shadow-lg">
          <Users className="text-blue-500 mx-auto mb-4" size={48} />
          <h3 className="text-3xl font-bold text-gray-800 mb-6">Would We Recommend?</h3>
          <div className="max-w-2xl mx-auto">
            <p className="text-xl text-gray-700 mb-6">
              Absolutely! Constantinou Bros Athena Beach Hotel exceeded our expectations in every way. 
              It's the perfect choice for families looking for a memorable Cyprus vacation.
            </p>
            <div className="flex justify-center gap-1 mb-6">
              {renderStars(5)}
            </div>
            <p className="text-lg font-semibold text-blue-600">
              5 out of 5 stars - Highly recommended for families!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Review;